module.exports = __webpack_public_path__ + "img/w3_add_add.ec336374.png";